// extracted by mini-css-extract-plugin
export default {"paymentIcons":"payment_paymentIcons__H0gVg"};